'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var TableView_module = require('../styles/TableView.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const TableView = React__namespace.forwardRef((props, ref) => {
    const { children, className, tableAttributes, ...restProps } = props;
    const { className: tableClassNames, ...restTableAttributes } = tableAttributes ?? {};
    const cx = reactUtils.useStyles(TableView_module.default);
    return (React__namespace.createElement("div", { ref: ref, className: cx(className, 'container'), ...restProps },
        React__namespace.createElement("table", { className: cx(tableClassNames, 'table'), ...restTableAttributes }, children)));
});

exports.TableView = TableView;
//# sourceMappingURL=TableView.js.map
